import { Gift, Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, StatusBadge } from "@/components/common";
import { useFetch } from "@/lib/useFetch";
import { t } from "@/i18n";

export const refKey = (slug) => `gf_ref_${slug}`;

export function ReferFriendCard({ slug }) {
  const { data } = useFetch(`/portal/${slug}/referral`);
  if (!data?.enabled) return null;
  const link = `${window.location.origin}${data.path}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success(t("ref.copied")); } catch { toast.error(t("ref.copyFailed")); }
  };
  return (
    <Card testId="portal-refer-card" className="min-w-0">
      <Gift className="h-5 w-5" style={{ color: "var(--brand)" }} />
      <p className="mt-3 font-display text-lg font-bold">{t("ref.portalTitle")}</p>
      <p className="mt-1 text-sm text-slate-600">{t("ref.portalText", { reward: data.reward })}</p>
      <div className="mt-3 flex items-center gap-2">
        <code className="min-w-0 flex-1 truncate rounded-md bg-slate-100 px-3 py-2 text-xs" data-testid="portal-referral-link">{link}</code>
        <Button size="sm" variant="outline" onClick={copy} aria-label={t("ref.copy")} data-testid="portal-referral-copy"><Copy className="h-4 w-4" /></Button>
      </div>
      <p className="mt-1 text-xs text-slate-500">{t("ref.code")}: <span className="font-mono font-semibold" data-testid="portal-referral-code">{data.code}</span></p>
      {data.items.length > 0 && <ul className="mt-3 space-y-1" data-testid="portal-referral-list">{data.items.map((r) => (
        <li key={r.id} className="flex items-center justify-between text-sm"><span>{r.friend}</span><StatusBadge status={r.status} /></li>
      ))}</ul>}
      <p className="mt-3 text-xs text-slate-500">{t("ref.portalRule")}</p>
    </Card>
  );
}
